export const notFoundStyles = {
  heading: {
    color: "peach.main",
    fontSize: {
      mobile: "4rem",
      tablet: "6rem",
    },
  },
  container: {
    pt: "3.438rem",
  },
  title: {
    color: "black.dark",
  },
  description: {
    color: "black.dark",
    my: "0.625rem",
    mb: "1.7rem",
    margin: "0.625rem auto 1.7rem",
    maxWidth: "50ch",
  },
};
